import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR } from '../../../../store/types'
import axios from 'axios'
import { authHeader, baseUrl } from '../../../../utils'
import { useParams } from 'react-router-dom'
import Loader from '../../../../components/elements/Loader'
import { PencilAltIcon } from '@heroicons/react/solid'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import EditScholarship from '../../../../components/partials/scholarships/EditScholarship'
import { clearCreatedStudentScholarship, clearDeletedStudentScholarship, clearUpdatedScholarship, deleteStudentScholarship, fetchStudentScholarships } from '../../../../store/actions/scholarshipsActions'
import EmptyState from '../../../../components/elements/EmptyState'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import AddBeneficiariesToScholarship from '../../../../components/partials/scholarships/AddBeneficiariesToScholarship'
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet'
import moment from 'moment'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'

const ScholarshipDetails = () => {
    const dispatch = useDispatch()
    const scholarshipsSelector = useSelector(state => state.scholarships)
    const [loading, setLoading] = useState(true)
    const [scholarshipDetails, setScholarshipDetails] = useState(null)
    const {scholarshipId} = useParams()
    
    useEffect(() => {
        dispatch(fetchStudentScholarships(`scholarship=${scholarshipId}`, 0, 0))
        const getScholarshipDetails = async () => {
            try {
                setLoading(true)
                const headers = authHeader()
                const response = await axios.get(`${baseUrl}/scholarships/${scholarshipId}?expand=department,designation`, { headers })
                
                setScholarshipDetails(response.data.data)
                setLoading(false)
            } catch (error) {
                dispatch({
                    type: ERROR,
                    error
                })            
            }
        }

        getScholarshipDetails()

        if(scholarshipsSelector.updatedScholarship !== null) {
            clearUpdatedScholarship()
        }

        if(scholarshipsSelector.createdStudentScholarship !== null) {
            clearCreatedStudentScholarship()
            setAddingBeneficiaries(false)
        }

        if(scholarshipsSelector.deletedStudentScholarship !== null) {
            clearDeletedStudentScholarship()
        }
    
        return () => {
            
        }
    }, [dispatch, scholarshipId, scholarshipsSelector.createdStudentScholarship, scholarshipsSelector.updatedScholarship, scholarshipsSelector.deletedStudentScholarship])

    const [editingScholarship, setEditingScholarship] = useState(false)

    const [addingBeneficiaries, setAddingBeneficiaries] = useState(false)
    

    const deleteBeneficiary = (studentName, id) => {
        if(window.confirm(`${studentName} will be removed from the beneficiaries of ${scholarshipDetails.name} are you sure you want to continue?`)){
            dispatch(deleteStudentScholarship(id))
        }
    }
    
    return (
        <>
            <AdministrationLayout>
                {loading ? 
                    <Loader />
                :
                    <div className='flex items-start justify-between gap-x-[20px] relative'>
                        <div className='w-[25%] sticky top-[50px]'>
                            <div className='w-full p-[20px] bg-gray-50'>    
                                <h3 className='font-medium text-gray-800 text-lg mb-2'>{scholarshipDetails.name}</h3>
                                <p className='text-sm text-gray-600'>{scholarshipDetails.description}</p>
                                
                                {scholarshipDetails.limits.limited && <span className='inline-block mt-[7px] px-[10px] py-[5px] bg-orange-300 font-space-grotesk bg-opacity-20 rounded text-xs'>Limited to {scholarshipDetails.limits.quantity.toLocaleString()} students</span>}
                                {!scholarshipDetails.limits.limited && <span className='inline-block px-[10px] py-[5px] mt-[10px] bg-green-500 font-medium font-space-grotesk bg-opacity-10 text-xs rounded '>Unlimited</span>}

                                <div className='mt-[10px]'>
                                    {scholarshipDetails.discount.type === 'PERCENTAGE' ?
                                        <p className='text-sm text-gray-600'><span className='text-black font-space-grotesk font-medium'>{scholarshipDetails.discount.amount}%</span> off all eligible invoices</p>
                                    :
                                        <p className='text-sm text-gray-600'><span className='text-black font-space-grotesk font-medium'>N{scholarshipDetails.discount.amount.toLocaleString()}</span> off all eligible invoices</p>
                                    }
                                </div>

                                <div className='mt-[20px] pt-[10px] border-t border-gray-300'>
                                    <button onClick={()=>{setEditingScholarship(true)}} className='flex font-medium text-gray-600 items-center gap-x-[5px] font-space-grotesk text-sm transition duration-200 hover:text-black'>
                                        Edit Scholarship Details
                                        <PencilAltIcon className={`w-4 h-4`} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className='w-[75%]'>
                            <div className='w-full flex items-start justify-between gap-x-[20px] pb-[20px] border-b border-gray-300'>
                                <div className='w-8/12'>
                                    <h3 className='font-medium font-space-grotesk mb-1'>Scholarship Beneficiaries</h3>
                                    <p className='text-sm text-gray-600'>A list of students currently benefitting fron this scholarship. Add more students by clicking on the "Add beneficiaries" button.</p>
                                </div>

                                <div>
                                    <button onClick={()=>{setAddingBeneficiaries(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                    <PlusIcon className='w-5 h-5' /> Add beneficiaries
                                    </button>
                                </div>
                            </div>
                            {scholarshipsSelector.loadingStudentScholarships ? 
                                <Loader />
                            :
                                <>
                                    {scholarshipsSelector.studentScholarships?.scholarships?.length > 0 ? 
                                        <div className='w-full mt-[20px]'>
                                            <div className='grid grid-cols-3 gap-2'>
                                                {scholarshipsSelector.studentScholarships?.scholarships?.map((beneficiary, beneficiaryIndex)=>(<div key={beneficiaryIndex} className='w-full bg-gray-50 bg-opacity-50 rounded p-[10px] border border-gray-200'>
                                                    <ApplicantTableSnippet applicant={beneficiary.student} showAdmissionNumber />
                                                    <p className='pl-[60px] mt-[5px] text-[13px] text-gray-600'>Assigned by {beneficiary.createdBy.fullName} on {moment(beneficiary.createdAt).format('MMMM Do YYYY')}</p>

                                                    <div className='flex flex-row-reverse gap-x-[5px] mt-[10px]'>
                                                        <button onClick={()=>{deleteBeneficiary(beneficiary.student.fullName, beneficiary._id)}} className='rounded bg-red-600 bg-opacity-5 font-[500] font-space-grotesk text-red-800 flex items-center justify-center gap-x-[5px] transition duration-200 hover:bg-opacity-20 px-[10px] py-[7px] text-xs'>
                                                            Remove Student
                                                            <TrashIcon className={`w-4 h-4`} />
                                                        </button>
                                                        {/* <button></button> */}
                                                    </div>
                                                </div>))}
                                            </div>
                                        </div>
                                    :
                                        <div className='w-full mt-[50px]'>
                                            <EmptyState emptyStateText={`No students benefitting from this scholarshiip yet. You can click on the "Add beneficiaries" button to add beneficiaries.`} />
                                        </div>}
                                </>
                            }
                        </div>
                    </div>
                }        
            </AdministrationLayout>

            <ModalDialog
                shown={editingScholarship} 
                closeFunction={()=>{setEditingScholarship(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Edit Scholarship'
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <EditScholarship scholarship={scholarshipDetails} close={()=>{setEditingScholarship(false)}} />
            </ModalDialog>

            <ModalDialog
                shown={addingBeneficiaries} 
                closeFunction={()=>{setAddingBeneficiaries(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle='Add Scholarship Beneficiaries'
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <AddBeneficiariesToScholarship scholarship={scholarshipDetails} close={()=>{setAddingBeneficiaries(false)}} />
            </ModalDialog>
        </>
    )
}

export default ScholarshipDetails